import { render, staticRenderFns } from "./AlphabetSideBar.vue?vue&type=template&id=6beaa4fb"
import script from "./AlphabetSideBar.vue?vue&type=script&lang=js"
export * from "./AlphabetSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports